!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Embed = t() : e.Embed = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 13);
  }([function (e, t, n) {
    var r = n(5),
        i = n(6),
        o = n(7);

    e.exports = function (e, t) {
      return r(e) || i(e, t) || o();
    };
  }, function (e, t) {
    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function r(t) {
      return "function" == typeof Symbol && "symbol" === n(Symbol.iterator) ? e.exports = r = function r(e) {
        return n(e);
      } : e.exports = r = function r(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : n(e);
      }, r(t);
    }

    e.exports = r;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t) {
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    e.exports = function (e, t, r) {
      return t && n(e.prototype, t), r && n(e, r), e;
    };
  }, function (e, t) {
    function n(e, t, n) {
      var r, i, o, a, s;

      function l() {
        var c = Date.now() - a;
        c < t && c >= 0 ? r = setTimeout(l, t - c) : (r = null, n || (s = e.apply(o, i), o = i = null));
      }

      null == t && (t = 100);

      var c = function c() {
        o = this, i = arguments, a = Date.now();
        var c = n && !r;
        return r || (r = setTimeout(l, t)), c && (s = e.apply(o, i), o = i = null), s;
      };

      return c.clear = function () {
        r && (clearTimeout(r), r = null);
      }, c.flush = function () {
        r && (s = e.apply(o, i), o = i = null, clearTimeout(r), r = null);
      }, c;
    }

    n.debounce = n, e.exports = n;
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      var n = [],
          r = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }

      return n;
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }, function (e, t, n) {
    var r = n(9);
    "string" == typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(11)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(10)(!1)).push([e.i, ".embed-tool--loading .embed-tool__caption {\n      display: none;\n    }\n\n    .embed-tool--loading .embed-tool__preloader {\n      display: block;\n    }\n\n    .embed-tool--loading .embed-tool__content {\n      display: none;\n    }\n  .embed-tool__preloader {\n    display: none;\n    position: relative;\n    height: 200px;\n    box-sizing: border-box;\n    border-radius: 5px;\n    border: 1px solid #e6e9eb;\n  }\n  .embed-tool__preloader::before {\n      content: '';\n      position: absolute;\n      z-index: 3;\n      left: 50%;\n      top: 50%;\n      width: 30px;\n      height: 30px;\n      margin-top: -25px;\n      margin-left: -15px;\n      border-radius: 50%;\n      border: 2px solid #cdd1e0;\n      border-top-color: #388ae5;\n      box-sizing: border-box;\n      animation: embed-preloader-spin 2s infinite linear;\n    }\n  .embed-tool__url {\n    position: absolute;\n    bottom: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    max-width: 250px;\n    color: #7b7e89;\n    font-size: 11px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .embed-tool__caption {\n    margin-top: 7px;\n  }\n  .embed-tool__caption[contentEditable=true][data-placeholder]::before{\n      position: absolute;\n      content: attr(data-placeholder);\n      color: #707684;\n      font-weight: normal;\n      opacity: 0;\n    }\n  .embed-tool__caption[contentEditable=true][data-placeholder]:empty::before {\n         opacity: 1;\n      }\n  .embed-tool__caption[contentEditable=true][data-placeholder]:empty:focus::before {\n        opacity: 0;\n      }\n\n@keyframes embed-preloader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n", ""]);
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" == typeof btoa) {
              var i = function (e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(r),
                  o = r.sources.map(function (e) {
                return "/*# sourceURL=" + r.sourceRoot + e + " */";
              });

              return [n].concat(o).concat([i]).join("\n");
            }

            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);

        for (var r = {}, i = 0; i < this.length; i++) {
          var o = this[i][0];
          "number" == typeof o && (r[o] = !0);
        }

        for (i = 0; i < e.length; i++) {
          var a = e[i];
          "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, n) {
    var r = {},
        i = function (e) {
      var t;
      return function () {
        return void 0 === t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        o = function (e) {
      var t = {};
      return function (e) {
        if ("function" == typeof e) return e();

        if (void 0 === t[e]) {
          var n = function (e) {
            return document.querySelector(e);
          }.call(this, e);

          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (e) {
            n = null;
          }
          t[e] = n;
        }

        return t[e];
      };
    }(),
        a = null,
        s = 0,
        l = [],
        c = n(12);

    function u(e, t) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n],
            o = r[i.id];

        if (o) {
          o.refs++;

          for (var a = 0; a < o.parts.length; a++) {
            o.parts[a](i.parts[a]);
          }

          for (; a < i.parts.length; a++) {
            o.parts.push(b(i.parts[a], t));
          }
        } else {
          var s = [];

          for (a = 0; a < i.parts.length; a++) {
            s.push(b(i.parts[a], t));
          }

          r[i.id] = {
            id: i.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function d(e, t) {
      for (var n = [], r = {}, i = 0; i < e.length; i++) {
        var o = e[i],
            a = t.base ? o[0] + t.base : o[0],
            s = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }

      return n;
    }

    function f(e, t) {
      var n = o(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = l[l.length - 1];
      if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), l.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var i = o(e.insertInto + " " + e.insertAt.before);
        n.insertBefore(t, i);
      }
    }

    function h(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = l.indexOf(e);
      t >= 0 && l.splice(t, 1);
    }

    function p(e) {
      var t = document.createElement("style");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), m(t, e.attrs), f(e, t), t;
    }

    function m(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }

    function b(e, t) {
      var n, r, i, o;

      if (t.transform && e.css) {
        if (!(o = t.transform(e.css))) return function () {};
        e.css = o;
      }

      if (t.singleton) {
        var l = s++;
        n = a || (a = p(t)), r = y.bind(null, n, l, !1), i = y.bind(null, n, l, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", m(t, e.attrs), f(e, t), t;
      }(t), r = function (e, t, n) {
        var r = n.css,
            i = n.sourceMap,
            o = void 0 === t.convertToAbsoluteUrls && i;
        (t.convertToAbsoluteUrls || o) && (r = c(r));
        i && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
        var a = new Blob([r], {
          type: "text/css"
        }),
            s = e.href;
        e.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
      }.bind(null, n, t), i = function i() {
        h(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = p(t), r = function (e, t) {
        var n = t.css,
            r = t.media;
        r && e.setAttribute("media", r);
        if (e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), i = function i() {
        h(n);
      });

      return r(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else i();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = i()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = d(e, t);
      return u(n, t), function (e) {
        for (var i = [], o = 0; o < n.length; o++) {
          var a = n[o];
          (s = r[a.id]).refs--, i.push(s);
        }

        e && u(d(e, t), t);

        for (o = 0; o < i.length; o++) {
          var s;

          if (0 === (s = i[o]).refs) {
            for (var l = 0; l < s.parts.length; l++) {
              s.parts[l]();
            }

            delete r[s.id];
          }
        }
      };
    };

    var v = function () {
      var e = [];
      return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();

    function y(e, t, n, r) {
      var i = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = v(t, i);else {
        var o = document.createTextNode(i),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(o, a[t]) : e.appendChild(o);
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" != typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" != typeof e) return e;
      var n = t.protocol + "//" + t.host,
          r = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var i,
            o = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(o) ? e : (i = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? n + o : r + o.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")");
      });
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(1),
        i = n.n(r),
        o = n(0),
        a = n.n(o),
        s = n(2),
        l = n.n(s),
        c = n(3),
        u = n.n(c),
        d = {
      vimeo: {
        regex: /(?:http[s]?:\/\/)?(?:www.)?vimeo\.co(?:.+\/([^\/]\d+)(?:#t=[\d]+)?s?$)/,
        embedUrl: "https://player.vimeo.com/video/<%= remote_id %>?title=0&byline=0",
        html: '<iframe style="width:100%;" height="320" frameborder="0"></iframe>',
        height: 320,
        width: 580
      },
      youtube: {
        regex: /(?:https?:\/\/)?(?:www\.)?(?:(?:youtu\.be\/)|(?:youtube\.com)\/(?:v\/|u\/\w\/|embed\/|watch))(?:(?:\?v=)?([^#&?=]*))?((?:[?&]\w*=\w*)*)/,
        embedUrl: "https://www.youtube.com/embed/<%= remote_id %>",
        html: '<iframe style="width:100%;" height="320" frameborder="0" allowfullscreen></iframe>',
        height: 320,
        width: 580,
        id: function id(e) {
          var t = a()(e, 2),
              n = t[0],
              r = t[1];
          if (!r && n) return n;
          var i = {
            start: "start",
            end: "end",
            t: "start",
            time_continue: "start",
            list: "list"
          };
          return r = r.slice(1).split("&").map(function (e) {
            var t = e.split("="),
                r = a()(t, 2),
                o = r[0],
                s = r[1];

            if (n || "v" !== o) {
              if (i[o]) return "".concat(i[o], "=").concat(s);
            } else n = s;
          }).filter(function (e) {
            return !!e;
          }), n + "?" + r.join("&");
        }
      },
      coub: {
        regex: /https?:\/\/coub\.com\/view\/([^\/\?\&]+)/,
        embedUrl: "https://coub.com/embed/<%= remote_id %>",
        html: '<iframe style="width:100%;" height="320" frameborder="0" allowfullscreen></iframe>',
        height: 320,
        width: 580
      },
      vine: {
        regex: /https?:\/\/vine\.co\/v\/([^\/\?\&]+)/,
        embedUrl: "https://vine.co/v/<%= remote_id %>/embed/simple/",
        html: '<iframe style="width:100%;" height="320" frameborder="0" allowfullscreen></iframe>',
        height: 320,
        width: 580
      },
      imgur: {
        regex: /https?:\/\/(?:i\.)?imgur\.com.*\/([a-zA-Z0-9]+)(?:\.gifv)?/,
        embedUrl: "http://imgur.com/<%= remote_id %>/embed",
        html: '<iframe allowfullscreen="true" scrolling="no" id="imgur-embed-iframe-pub-<%= remote_id %>" class="imgur-embed-iframe-pub" style="height: 500px; width: 100%; border: 1px solid #000"></iframe>',
        height: 500,
        width: 540
      },
      gfycat: {
        regex: /https?:\/\/gfycat\.com(?:\/detail)?\/([a-zA-Z]+)/,
        embedUrl: "https://gfycat.com/ifr/<%= remote_id %>",
        html: "<iframe frameborder='0' scrolling='no' style=\"width:100%;\" height='436' allowfullscreen ></iframe>",
        height: 436,
        width: 580
      },
      "twitch-channel": {
        regex: /https?:\/\/www\.twitch\.tv\/([^\/\?\&]*)\/?$/,
        embedUrl: "https://player.twitch.tv/?channel=<%= remote_id %>",
        html: '<iframe frameborder="0" allowfullscreen="true" scrolling="no" height="366" style="width:100%;"></iframe>',
        height: 366,
        width: 600
      },
      "twitch-video": {
        regex: /https?:\/\/www\.twitch\.tv\/(?:[^\/\?\&]*\/v|videos)\/([0-9]*)/,
        embedUrl: "https://player.twitch.tv/?video=v<%= remote_id %>",
        html: '<iframe frameborder="0" allowfullscreen="true" scrolling="no" height="366" style="width:100%;"></iframe>',
        height: 366,
        width: 600
      },
      "yandex-music-album": {
        regex: /https?:\/\/music\.yandex\.ru\/album\/([0-9]*)\/?$/,
        embedUrl: "https://music.yandex.ru/iframe/#album/<%= remote_id %>/",
        html: '<iframe frameborder="0" style="border:none;width:540px;height:400px;" style="width:100%;" height="400"></iframe>',
        height: 400,
        width: 540
      },
      "yandex-music-track": {
        regex: /https?:\/\/music\.yandex\.ru\/album\/([0-9]*)\/track\/([0-9]*)/,
        embedUrl: "https://music.yandex.ru/iframe/#track/<%= remote_id %>/",
        html: '<iframe frameborder="0" style="border:none;width:540px;height:100px;" style="width:100%;" height="100"></iframe>',
        height: 100,
        width: 540,
        id: function id(e) {
          return e.join("/");
        }
      },
      "yandex-music-playlist": {
        regex: /https?:\/\/music\.yandex\.ru\/users\/([^\/\?\&]*)\/playlists\/([0-9]*)/,
        embedUrl: "https://music.yandex.ru/iframe/#playlist/<%= remote_id %>/show/cover/description/",
        html: '<iframe frameborder="0" style="border:none;width:540px;height:400px;" width="540" height="400"></iframe>',
        height: 400,
        width: 540,
        id: function id(e) {
          return e.join("/");
        }
      },
      codepen: {
        regex: /https?:\/\/codepen\.io\/([^\/\?\&]*)\/pen\/([^\/\?\&]*)/,
        embedUrl: "https://codepen.io/<%= remote_id %>?height=300&theme-id=0&default-tab=css,result&embed-version=2",
        html: "<iframe height='300' scrolling='no' frameborder='no' allowtransparency='true' allowfullscreen='true' style='width: 100%;'></iframe>",
        height: 300,
        width: 600,
        id: function id(e) {
          return e.join("/embed/");
        }
      }
    },
        f = (n(8), n(4));
    n.d(t, "default", function () {
      return h;
    });

    var h = function () {
      function e(t) {
        var n = t.data,
            r = t.api;
        l()(this, e), this.api = r, this._data = {}, this.element = null, this.data = n;
      }

      return u()(e, [{
        key: "render",
        value: function value() {
          var t = this;

          if (!this.data.service) {
            var n = document.createElement("div");
            return this.element = n, n;
          }

          var r = e.services[this.data.service].html,
              i = document.createElement("div"),
              o = document.createElement("div"),
              a = document.createElement("template"),
              s = this.createPreloader();
          i.classList.add(this.CSS.baseClass, this.CSS.container, this.CSS.containerLoading), o.classList.add(this.CSS.input, this.CSS.caption), i.appendChild(s), o.contentEditable = !0, o.dataset.placeholder = "Enter a caption", o.innerHTML = this.data.caption || "", a.innerHTML = r, a.content.firstChild.setAttribute("src", this.data.embed), a.content.firstChild.classList.add(this.CSS.content);
          var l = this.embedIsReady(i);
          return i.appendChild(a.content.firstChild), i.appendChild(o), l.then(function () {
            i.classList.remove(t.CSS.containerLoading);
          }), this.element = i, i;
        }
      }, {
        key: "createPreloader",
        value: function value() {
          var e = document.createElement("preloader"),
              t = document.createElement("div");
          return t.textContent = this.data.source, e.classList.add(this.CSS.preloader), t.classList.add(this.CSS.url), e.appendChild(t), e;
        }
      }, {
        key: "save",
        value: function value() {
          return this.data;
        }
      }, {
        key: "onPaste",
        value: function value(t) {
          var n = t.detail,
              r = n.key,
              i = n.data,
              o = e.services[r],
              a = o.regex,
              s = o.embedUrl,
              l = o.width,
              c = o.height,
              u = o.id,
              d = void 0 === u ? function (e) {
            return e.shift();
          } : u,
              f = a.exec(i).slice(1),
              h = s.replace(/<\%\= remote\_id \%\>/g, d(f));
          this.data = {
            service: r,
            source: i,
            embed: h,
            width: l,
            height: c
          };
        }
      }, {
        key: "embedIsReady",
        value: function value(e) {
          var t = null;
          return new Promise(function (n, r) {
            (t = new MutationObserver(Object(f.debounce)(n, 450))).observe(e, {
              childList: !0,
              subtree: !0
            });
          }).then(function () {
            t.disconnect();
          });
        }
      }, {
        key: "data",
        set: function set(e) {
          if (!(e instanceof Object)) throw Error("Embed Tool data should be object");
          var t = e.service,
              n = e.source,
              r = e.embed,
              i = e.width,
              o = e.height,
              a = e.caption,
              s = void 0 === a ? "" : a;
          this._data = {
            service: t || this.data.service,
            source: n || this.data.source,
            embed: r || this.data.embed,
            width: i || this.data.width,
            height: o || this.data.height,
            caption: s || this.data.caption || ""
          };
          var l = this.element;
          l && l.parentNode.replaceChild(this.render(), l);
        },
        get: function get() {
          if (this.element) {
            var e = this.element.querySelector(".".concat(this.api.styles.input));
            this._data.caption = e ? e.innerHTML : "";
          }

          return this._data;
        }
      }, {
        key: "CSS",
        get: function get() {
          return {
            baseClass: this.api.styles.block,
            input: this.api.styles.input,
            container: "embed-tool",
            containerLoading: "embed-tool--loading",
            preloader: "embed-tool__preloader",
            caption: "embed-tool__caption",
            url: "embed-tool__url",
            content: "embed-tool__content"
          };
        }
      }], [{
        key: "prepare",
        value: function value(t) {
          var n = t.config,
              r = (void 0 === n ? {} : n).services,
              o = void 0 === r ? {} : r,
              s = Object.entries(d),
              l = Object.entries(o).filter(function (e) {
            var t = a()(e, 2),
                n = (t[0], t[1]);
            return "boolean" == typeof n && !0 === n;
          }).map(function (e) {
            return a()(e, 1)[0];
          }),
              c = Object.entries(o).filter(function (e) {
            var t = a()(e, 2),
                n = (t[0], t[1]);
            return "object" === i()(n);
          }).filter(function (t) {
            var n = a()(t, 2),
                r = (n[0], n[1]);
            return e.checkServiceConfig(r);
          }).map(function (e) {
            var t = a()(e, 2),
                n = t[0],
                r = t[1];
            return [n, {
              regex: r.regex,
              embedUrl: r.embedUrl,
              html: r.html,
              height: r.height,
              width: r.width,
              id: r.id
            }];
          });
          l.length && (s = s.filter(function (e) {
            var t = a()(e, 1)[0];
            return l.includes(t);
          })), s = s.concat(c), e.services = s.reduce(function (e, t) {
            var n = a()(t, 2),
                r = n[0],
                i = n[1];
            return r in e ? (e[r] = Object.assign({}, e[r], i), e) : (e[r] = i, e);
          }, {}), e.patterns = s.reduce(function (e, t) {
            var n = a()(t, 2),
                r = n[0],
                i = n[1];
            return e[r] = i.regex, e;
          }, {});
        }
      }, {
        key: "checkServiceConfig",
        value: function value(e) {
          var t = e.regex,
              n = e.embedUrl,
              r = e.html,
              i = e.height,
              o = e.width,
              a = e.id,
              s = t && t instanceof RegExp && n && "string" == typeof n && r && "string" == typeof r;
          return s = (s = (s = s && (void 0 === a || a instanceof Function)) && (void 0 === i || Number.isFinite(i))) && (void 0 === o || Number.isFinite(o));
        }
      }, {
        key: "pasteConfig",
        get: function get() {
          return {
            patterns: e.patterns
          };
        }
      }]), e;
    }();
  }]).default;
});